angular.module('autoremind.dashboard.directives')
    .directive('recallsWidget', ['$rootScope',
    function ($rootScope) {
        return {
            templateUrl: 'app/dashboard/widgets/recalls/recalls.html',
            restrict: 'EA',
            scope: true,
        };
    }]);
//# sourceMappingURL=recalls.directive.js.map